import PendoIframe from 'lib/components/pendo-iframe/pendo-iframe'

export default PendoIframe
